const SolutionHelper = {
  pieTableHelper: props => {
    let getPortfolioData = props.getBacktest.getPortfolioData;
    let portfolioFilter = [];
    let portfolioData = {};
    let PieData = [];

    for (let i in getPortfolioData) {
      let line = getPortfolioData[i];
      if (
        i == 0 ||
        (portfolioFilter[portfolioFilter.length - 1] &&
          portfolioFilter[portfolioFilter.length - 1].value != line.dt)
      ) {
        portfolioFilter.push({
          value: line.dt
        });
      }

      line.dt in portfolioData
        ? portfolioData[line.dt].push([
            line.symbol,
            line.fund_name,
            line.fund_asset_class_focus,
            line.allocation,
            line.style
          ])
        : (portfolioData[line.dt] = [
            [
              line.symbol,
              line.fund_name,
              line.fund_asset_class_focus,
              line.allocation,
              line.style
            ]
          ]);

      line.dt in PieData
        ? PieData[line.dt].push({
            fund: line.fund_asset_class_focus,
            allocation: line.allocation * 1,
            style: line.style
          })
        : (PieData[line.dt] = [
            {
              fund: line.fund_asset_class_focus,
              allocation: line.allocation * 1,
              style: line.style
            }
          ]);
    }
    let newData = [];
    let newPieData = [];

    if (portfolioFilter.length > 0) {
      newData =
        portfolioData[portfolioFilter[portfolioFilter.length - 1].value];
    }
    if (portfolioFilter.length > 0) {
      newPieData = PieData[portfolioFilter[portfolioFilter.length - 1].value];
    }

    return [newData, newPieData];
  }
};

export default SolutionHelper;



// WEBPACK FOOTER //
// ./src/components/pages/Retire/solution/solution.helper.js